(function () {
  var configEl = document.getElementById('blog-conversion-config');
  if (!configEl || configEl.getAttribute('data-enabled') !== 'true') return;

  var config = {
    ctaType: configEl.getAttribute('data-cta-type') || '',
    productUrl: configEl.getAttribute('data-product-url') || '/products/playermaker',
    trackerUrl: configEl.getAttribute('data-tracker-url') || '/pages/soccer-tracker',
    articleUrl: configEl.getAttribute('data-article-url') || window.location.pathname,
    articleTitle: configEl.getAttribute('data-article-title') || document.title,
    stickyText: configEl.getAttribute('data-sticky-text') || 'Track Your Game with Playermaker →',
    stickyUrl: configEl.getAttribute('data-sticky-url') || '/pages/soccer-tracker',
    pageType: configEl.getAttribute('data-page-type') || '',
    popupEnabled: configEl.getAttribute('data-popup-enabled') === 'true',
    customerId: configEl.getAttribute('data-customer-id') || ''
  };

  var copy = getCopy(config.ctaType);
  var articlePage = document.querySelector('.blog-article-page');
  if (articlePage) articlePage.classList.add('has-blog-conversion');

  trackEvent('blog_article_session', {
    cta_type: config.ctaType,
    cta_position: 'page_load'
  });

  markBlogAttribution();
  injectMidLateCTAs(copy);
  initImpressionTracking();
  initClickTracking();
  initStickyBar();
  initEmailTracking();
  initGuidePopup();
  initBlogLeadForms();

  function getCopy(type) {
    if (type === 'a') {
      return {
        heading: 'Want to improve your game with real performance data?',
        text: 'See how Playermaker helps players understand their physical and technical performance.',
        button: 'See How Playermaker Works',
        url: config.trackerUrl
      };
    }
    if (type === 'b') {
      return {
        heading: 'Training is only useful if you know you’re improving.',
        text: 'Playermaker tracks your technical and physical performance so you can see progress over time.',
        button: 'Track Your Progress',
        url: config.trackerUrl
      };
    }
    if (type === 'c') {
      var highIntent = /gift|gps-vests-vs|vests-vs|vs-football-tracker/.test(window.location.pathname);
      return {
        heading: 'GPS tracks movement. Playermaker develops players.',
        text: 'Track technical and physical performance, indoors and outdoors.',
        button: highIntent ? 'Shop Playermaker' : 'Discover Playermaker',
        url: config.productUrl
      };
    }
    return null;
  }

  function buildCtaHtml(position, copyData) {
    if (!copyData) return '';
    var url = withUtm(copyData.url, position, config.ctaType);
    return (
      '<aside class="blog-cta" data-blog-cta data-cta-type="' +
      escapeHtml(config.ctaType) +
      '" data-cta-position="' +
      escapeHtml(position) +
      '" data-destination-url="' +
      escapeHtml(url) +
      '">' +
      '<h3 class="blog-cta__heading">' +
      escapeHtml(copyData.heading) +
      '</h3>' +
      '<p class="blog-cta__text">' +
      escapeHtml(copyData.text) +
      '</p>' +
      '<a class="blog-cta__button blog-conversion-link" href="' +
      escapeHtml(url) +
      '" data-cta-type="' +
      escapeHtml(config.ctaType) +
      '" data-cta-position="' +
      escapeHtml(position) +
      '" data-destination-url="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(copyData.button) +
      '</a>' +
      '</aside>'
    );
  }

  function injectMidLateCTAs(copyData) {
    if (!copyData) return;
    var body = document.querySelector('.blog-article-content__body');
    if (!body) return;

    var blocks = body.querySelectorAll(
      ':scope > p, :scope > ul, :scope > ol, :scope > h2, :scope > h3, :scope > blockquote, :scope > div'
    );
    var meaningful = Array.prototype.filter.call(blocks, function (node) {
      return node.textContent.trim().length > 0;
    });

    if (meaningful.length < 4) return;

    var earlyIndex = Math.max(1, Math.floor(meaningful.length * 0.3) - 1);
    var lateIndex = Math.max(earlyIndex + 1, Math.floor(meaningful.length * 0.75) - 1);

    insertHtmlAfter(buildCtaHtml('mid_article', copyData), meaningful[earlyIndex]);
    insertHtmlAfter(buildCtaHtml('late_article', copyData), meaningful[lateIndex]);
  }

  function insertHtmlAfter(html, node) {
    if (!html || !node || !node.parentNode) return;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var element = wrapper.firstElementChild;
    if (!element) return;
    node.parentNode.insertBefore(element, node.nextSibling);
  }

  function initImpressionTracking() {
    if (!('IntersectionObserver' in window)) return;
    var seen = new WeakSet();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          trackEvent('blog_cta_impression', getBlockMeta(entry.target));
        });
      },
      { threshold: 0.35 }
    );

    document.querySelectorAll('[data-blog-cta], .blog-email-capture, .blog-end-conversion, .blog-sticky-cta').forEach(function (el) {
      observer.observe(el);
    });
  }

  function initClickTracking() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.blog-conversion-link, .blog-sticky-cta__link, .blog-end-conversion__primary, .blog-end-conversion__secondary');
      if (!link) return;

      var meta = getBlockMeta(link.closest('[data-blog-cta], .blog-end-conversion, .blog-sticky-cta') || link);
      trackEvent('blog_cta_click', meta);

      if ((meta.destination_url || link.href || '').indexOf('/products/') !== -1) {
        trackEvent('product_page_visit_from_blog', meta);
      }
    });
  }

  function initEmailTracking() {
    document.querySelectorAll('#blog-email-capture .blog-email-capture__message--success').forEach(function (node) {
      trackEvent('email_signup_from_blog', {
        cta_type: config.ctaType,
        cta_position: 'email_capture',
        destination_url: window.location.href
      });
    });
  }

  function whenBrazeReady(callback) {
    if (typeof window.ensurePlayermakerBraze === 'function') {
      window.ensurePlayermakerBraze(callback);
      return;
    }

    if (window.braze && typeof window.braze.logCustomEvent === 'function') {
      callback(window.braze);
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.braze && typeof window.braze.logCustomEvent === 'function') {
        clearInterval(timer);
        callback(window.braze);
      } else if (tries >= 25) {
        clearInterval(timer);
        callback(null);
      }
    }, 200);
  }

  function normalizeLeadEmail(email) {
    return String(email || '')
      .trim()
      .toLowerCase();
  }

  function sendBlogLeadToBraze(email, source, done) {
    var normalizedEmail = normalizeLeadEmail(email);
    if (!normalizedEmail) {
      done(false);
      return;
    }

    whenBrazeReady(function (brazeSdk) {
      if (!brazeSdk) {
        done(false);
        return;
      }

      try {
        if (typeof brazeSdk.changeUser === 'function') {
          brazeSdk.changeUser(normalizedEmail);
        }

        var user = typeof brazeSdk.getUser === 'function' ? brazeSdk.getUser() : null;
        if (user) {
          if (typeof user.setEmail === 'function') {
            user.setEmail(normalizedEmail);
          }
          if (typeof user.setCustomUserAttribute === 'function') {
            user.setCustomUserAttribute('blog_lead', true);
            user.setCustomUserAttribute('lead_source', 'blog');
            user.setCustomUserAttribute('blog_lead_source', source);
            user.setCustomUserAttribute('blog_article_url', config.articleUrl || '');
            user.setCustomUserAttribute('blog_article_title', config.articleTitle || '');
          }
          try {
            var optedIn =
              (brazeSdk.User &&
                brazeSdk.User.NotificationSubscriptionTypes &&
                brazeSdk.User.NotificationSubscriptionTypes.OPTED_IN) ||
              'opted_in';
            if (typeof user.setEmailNotificationSubscriptionType === 'function') {
              user.setEmailNotificationSubscriptionType(optedIn);
            }
          } catch (subscriptionError) {}
        }

        brazeSdk.logCustomEvent('Blog_Lead', {
          source: source,
          blog_lead: true,
          article_url: config.articleUrl || '',
          article_title: config.articleTitle || '',
          cta_type: config.ctaType || ''
        });

        var finished = false;
        function complete(success) {
          if (finished) return;
          finished = true;
          done(success);
        }

        if (typeof brazeSdk.requestImmediateDataFlush === 'function') {
          brazeSdk.requestImmediateDataFlush(
            function () {
              complete(true);
            },
            function () {
              complete(false);
            }
          );
          setTimeout(function () {
            complete(true);
          }, 3000);
        } else {
          complete(true);
        }
      } catch (error) {
        done(false);
      }
    });
  }

  function showBlogLeadSuccess(form, source) {
    var container = form.closest('[data-success-message]') || form;
    var message =
      (container && container.getAttribute('data-success-message')) ||
      'Thanks — your guide is on the way.';
    var existing = form.querySelector('.blog-email-capture__message--success');
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'blog-email-capture__message blog-email-capture__message--success';
      form.appendChild(existing);
    }
    existing.textContent = message;

    form.querySelectorAll('input[type="email"], button[type="submit"]').forEach(function (el) {
      el.disabled = true;
    });

    try {
      window.localStorage.setItem('blogGuidePopupDismissed', '1');
    } catch (error) {}

    trackEvent('email_signup_from_blog', {
      cta_type: config.ctaType,
      cta_position: source,
      destination_url: window.location.href
    });
  }

  function showBlogLeadError(form, message) {
    var existing = form.querySelector('.blog-email-capture__message--error');
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'blog-email-capture__message blog-email-capture__message--error';
      form.appendChild(existing);
    }
    existing.textContent = message;
  }

  function initBlogLeadForms() {
    document.querySelectorAll('#BlogGuideSignup, #BlogGuideSignupPopup').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? String(emailInput.value || '').trim() : '';
        if (!email) return;

        var source = form.id === 'BlogGuideSignupPopup' ? 'guide_popup' : 'email_capture';
        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        form.querySelectorAll('.blog-email-capture__message--error').forEach(function (node) {
          node.remove();
        });

        trackEvent('blog_cta_click', {
          cta_type: config.ctaType,
          cta_position: source,
          destination_url: window.location.href
        });

        sendBlogLeadToBraze(email, source, function (success) {
          if (!success) {
            if (submitButton) submitButton.disabled = false;
            showBlogLeadError(
              form,
              'Something went wrong sending your guide. Please try again in a moment.'
            );
            return;
          }

          showBlogLeadSuccess(form, source);
          try {
            fetch(form.action || window.location.href, {
              method: form.method || 'POST',
              body: new FormData(form),
              credentials: 'same-origin'
            });
          } catch (error) {}
        });
      });
    });
  }

  function isArticlePage() {
    if (config.pageType && config.pageType !== 'article') return false;
    if (!document.querySelector('.blog-article-page')) return false;
    if (document.body.classList.contains('article')) return true;

    var path = window.location.pathname.replace(/\/+$/, '').split('/');
    return path[1] === 'blogs' && path.length >= 4;
  }

  function initGuidePopup() {
    var popup = document.getElementById('blog-guide-popup');
    if (!popup || !config.popupEnabled || !isArticlePage()) return;

    if (popup.parentNode !== document.body) {
      document.body.appendChild(popup);
    }

    var openers = document.querySelectorAll('[data-blog-popup-open]');
    var closers = popup.querySelectorAll('[data-blog-popup-close]');
    var lastFocus = null;
    var autoTimer = null;
    var shownThisVisit = false;
    var dismissKey = 'blogGuidePopupDismissed';

    function isOpen() {
      return popup.classList.contains('is-open');
    }

    function clearAutoTimer() {
      if (!autoTimer) return;
      clearTimeout(autoTimer);
      autoTimer = null;
    }

    function markDismissed() {
      try {
        window.localStorage.setItem(dismissKey, '1');
      } catch (error) {}
    }

    function wasDismissed() {
      try {
        return window.localStorage.getItem(dismissKey) === '1';
      } catch (error) {
        return false;
      }
    }

    function openPopup() {
      clearAutoTimer();
      if (isOpen() || !isArticlePage()) return;
      shownThisVisit = true;
      lastFocus = document.activeElement;
      popup.removeAttribute('hidden');
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      var input = popup.querySelector('#BlogGuidePopupEmail');
      if (input) input.focus();
      trackEvent('blog_cta_impression', {
        cta_type: config.ctaType,
        cta_position: 'guide_popup',
        destination_url: '#blog-guide-popup'
      });
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      markDismissed();
      clearAutoTimer();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openers.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (wasDismissed()) return;
        openPopup();
      });
    });

    closers.forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        closePopup();
      }
    });

    var popupForm = popup.querySelector('.blog-guide-popup__form');
    if (popupForm) {
      popupForm.addEventListener('submit', function () {
        markDismissed();
      });
    }

    if (wasDismissed()) return;

    if (popup.querySelector('.blog-email-capture__message--success')) {
      openPopup();
      trackEvent('email_signup_from_blog', {
        cta_type: config.ctaType,
        cta_position: 'guide_popup',
        destination_url: window.location.href
      });
      return;
    }

    autoTimer = setTimeout(function () {
      if (!shownThisVisit && !isOpen() && !wasDismissed() && isArticlePage()) {
        openPopup();
      }
    }, 20000);
  }

  function initStickyBar() {
    var bar = document.getElementById('blog-sticky-cta');
    if (!bar) return;

    var storageKey = 'blogStickyDismissed:' + config.articleUrl;
    if (window.localStorage.getItem(storageKey) === '1') return;

    var link = bar.querySelector('.blog-sticky-cta__link');
    var close = bar.querySelector('.blog-sticky-cta__close');
    if (link) {
      link.textContent = config.stickyText;
      link.href = withUtm(config.stickyUrl, 'sticky_mobile', config.ctaType);
      link.classList.add('blog-conversion-link');
      link.setAttribute('data-cta-type', config.ctaType);
      link.setAttribute('data-cta-position', 'sticky_mobile');
      link.setAttribute('data-destination-url', link.href);
    }

    setTimeout(function () {
      bar.classList.add('is-visible');
    }, 1200);

    if (close) {
      close.addEventListener('click', function () {
        bar.classList.remove('is-visible');
        window.localStorage.setItem(storageKey, '1');
      });
    }
  }

  function markBlogAttribution() {
    try {
      sessionStorage.setItem(
        'pm_blog_attribution',
        JSON.stringify({
          article_url: config.articleUrl,
          article_title: config.articleTitle,
          cta_type: config.ctaType,
          timestamp: Date.now()
        })
      );
    } catch (error) {}
  }

  function withUtm(url, position, type) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('utm_source', 'blog');
      parsed.searchParams.set('utm_medium', position);
      parsed.searchParams.set('utm_campaign', 'blog_phase1_' + type);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function getBlockMeta(node) {
    if (!node) return {};
    return {
      cta_type: node.getAttribute('data-cta-type') || config.ctaType,
      cta_position: node.getAttribute('data-cta-position') || '',
      destination_url: node.getAttribute('data-destination-url') || '',
      blog_article_url: config.articleUrl,
      device: window.innerWidth < 750 ? 'mobile' : 'desktop'
    };
  }

  function trackEvent(name, params) {
    var payload = Object.assign(
      {
        blog_article_url: config.articleUrl,
        device: window.innerWidth < 750 ? 'mobile' : 'desktop'
      },
      params || {}
    );

    if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
